import { TileSizes } from '@ad-lucy/components/layout/Grid/TileSizeContext';
import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid2xFx0 = (): GridInterface[] =>
  defineGrid('2:F:0', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'end',
            },
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'start',
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              spanCol: 2,
              spanRow: 2,
              fullSize: true,
            },
          ],
        },
      ],
    },
    {
      name: BREAKPOINT_DISPLAY_NAME.HPA,
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'center',
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'center',
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
              fullSize: true,
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 1/2',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 2/2',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 2,
              spanRow: 2,
              fullSize: true,
            },
          ],
        },
      ],
    },
  ]);
